import log from 'loglevel'
/**
 * Makes class changes to move the capture container and add/remove selected styles on the relevant elements.
 * @param {number} previousIndex The index of the previously selected element
 * @param {number} currentIndex The index of the newly selected element
 */

let totalOffset = 0

export const scrollToElement = (previousIndex, currentIndex, pageNumber = 0, pageChange = false, forward = false) => {
  // TODO: [LG-75] make non-active violation smaller on the screen: this.props.user.accountId
  if (pageChange && forward) {
    currentIndex = 2
  } else if (pageChange && !forward) {
    currentIndex = 0
  }

  const currentElement = document.getElementById(currentIndex.toString())
  // Stop if the element doesn't exist
  if (!currentElement) {
    log.warn('stopping. element does not exist')
    totalOffset = 0
    return false
  }

  const previousElements = document.getElementsByClassName('active-table')
  const previousElement = previousElements[0]

  if (previousElement && document.getElementById('violationContainer').classList.contains('slider')) {
    // Remove active class from previous element
    previousElement.classList.remove('active-table')
    previousElement.classList.add('violation-table')
  }

  if (currentElement && document.getElementById('violationContainer').classList.contains('slider')) {
    // Add active class to current element
    currentElement.classList.remove('violation-table')
    currentElement.classList.add('active-table')
  }

  // Scroll to next element
  const container = document.getElementById('violationContainer')
  // Hard coding height values based on CSS styles
  const activeHeight = 360
  const normalHeight = 300
  // Height of the table elements
  const factor = Math.abs(currentIndex - previousIndex)
  const offset = ((activeHeight + normalHeight) / 4) * factor

  totalOffset = pageChange ? 0 : previousIndex > currentIndex ? totalOffset - offset : totalOffset + offset
  container.style.cssText = `transform: translateY(-${totalOffset}px)`

  return currentElement.dataset.violationkey || null
}

/**
 * Moves to the next or previous list of captures after the user clicks the forward/back icon.
 * @param {number} currentIndex Index of the currently selected element
 * @param {number} pageNumber Number of the current page
 * @param {boolean} forward Did the user click on the forward button?
 */

// TODO fully refactor this after showcase
export const scrollToTop = (currentIndex, pageNumber) => {
  log.info('scrolling to top')
  scrollToElement(1, 0, pageNumber, true)
}
